import React, { useState, useEffect } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const TicketsQueueSelect = ({
	userQueues,
	selectedQueueIds = [],
	onChange,
}) => {
	const [allQueues, setAllQueues] = useState([]);
	const [loading, setLoading] = useState(false);

	// Buscar todas as filas se userQueues estiver vazio
	useEffect(() => {
		const fetchQueues = async () => {
			if (!userQueues || userQueues.length === 0) {
				setLoading(true);
				try {
					const { data } = await api.get('/queue');
					setAllQueues(data);
				} catch (err) {
					console.error('Erro ao buscar filas:', err);
					toastError(err);
				} finally {
					setLoading(false);
				}
			}
		};

		fetchQueues();
	}, [userQueues]);

	const handleChange = e => {
		onChange(e.target.value);
	};

	// Usar userQueues se disponível, senão usar allQueues
	const queuesToShow = userQueues && userQueues.length > 0 ? userQueues : allQueues;

	return (
		<div style={{ width: 120, marginTop: -4 }}>
			<FormControl fullWidth margin="dense">
				<Select
					multiple
					displayEmpty
					variant="outlined"
					value={selectedQueueIds}
					onChange={handleChange}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={() => i18n.t("ticketsQueueSelect.placeholder")}
					disabled={loading}
				>
					{queuesToShow?.length > 0 &&
						queuesToShow.map(queue => (
							<MenuItem dense key={queue.id} value={queue.id}>
								<Checkbox
									style={{
										color: queue.color,
									}}
									size="small"
									color="primary"
									checked={selectedQueueIds.indexOf(queue.id) > -1}
								/>
								<ListItemText primary={queue.name} />
							</MenuItem>
						))}
					{queuesToShow?.length === 0 && !loading && (
						<MenuItem disabled>
							<ListItemText primary="Nenhuma fila encontrada" />
						</MenuItem>
					)}
					{loading && (
						<MenuItem disabled>
							<ListItemText primary="Carregando filas..." />
						</MenuItem>
					)}
				</Select>
			</FormControl>
		</div>
	);
};

export default TicketsQueueSelect;
